export default __webpack_public_path__ + "static/syncstage-built-for-scale-0c3a9d1968cefad4279d2e15446969f6.png";